import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/convenio-medico`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms = {}) {

            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}